module.exports = __webpack_public_path__ + "img/bbb.fb8f8013.png";